export const initialNodeStyle = {
  "background-color": "white",
  label: (ele) => ele.data("label"),
  "text-valign": "center",
  "text-halign": "center",
  width: "20px",
  height: "20px",
  color: "black",
  "border-width": 1,
  "border-color": "black",
  "font-size": "10px",
};

export const flowInitialDirectedWeightedEdgeStyle = {
  "curve-style": "straight", // Use unbundled-bezier for better edge separation
  "control-point-step-size": 30,
  "line-color": "black",
  width: 2,
  label: (ele) => ele.data("weight"),
  "text-background-color": "white",
  "text-background-opacity": 1,
  "target-arrow-shape": "triangle",
  "target-arrow-color": "black",
  "text-rotation": "autorotate", // Automatically rotate the label
  "text-margin-y": -10, // Adjust the vertical margin to position the label above the arrow
  "text-margin-x": (ele) => {
    const sourcePos = ele.source().position();
    const targetPos = ele.target().position();
    return sourcePos.x > targetPos.x ? -10 : 10;
  },
  "text-halign": "center", // Align text to the center horizontally
  "text-valign": "top",
};
export const initialDirectedWeightedEdgeStyle = {
  "curve-style": "unbundled-bezier", // Use unbundled-bezier for better edge separation
  "control-point-step-size": 30,
  "line-color": "black",
  width: 2,
  label: (ele) => ele.data("weight"),
  "text-background-color": "white",
  "text-background-opacity": 1,
  "target-arrow-shape": "triangle",
  "target-arrow-color": "black",
  "text-rotation": "autorotate", // Automatically rotate the label
  "text-margin-y": -10, // Adjust the vertical margin to position the label above the arrow
  "text-margin-x": (ele) => {
    const sourcePos = ele.source().position();
    const targetPos = ele.target().position();
    return sourcePos.x > targetPos.x ? -10 : 10;
  },
  "text-halign": "center", // Align text to the center horizontally
  "text-valign": "top",
};

export const visitedDirectedWeightedEdgeStyle = {
  "curve-style": "unbundled-bezier", // Use unbundled-bezier for better edge separation
  "control-point-step-size": 30,
  "line-color": "green",
  width: 2,
  label: (ele) => ele.data("weight"),
  "text-background-color": "white",
  "text-background-opacity": 1,
  "target-arrow-shape": "triangle",
  "target-arrow-color": "green",
  "text-rotation": "autorotate", // Automatically rotate the label
  "text-margin-y": -10, // Adjust the vertical margin to position the label above the arrow
  "text-margin-x": -10,
};

export const visitingDirectedWeightedEdgeStyle = {
  "curve-style": "straight", // Use unbundled-bezier for better edge separation
  "control-point-step-size": 30,
  "line-color": "grey",
  width: 2,
  label: (ele) => ele.data("weight"),
  "text-background-color": "white",
  "text-background-opacity": 1,
  "target-arrow-shape": "triangle",
  "target-arrow-color": "grey",
  "text-rotation": "autorotate", // Automatically rotate the label
  "text-margin-y": -10, // Adjust the vertical margin to position the label above the arrow
  "text-margin-x": -10,
};

export const visitedNodeStyle = {
  "background-color": "black",
  color: "white",
};

export const visitedDirectedEdgeStyle = {
  "curve-style": "straight",
  "control-point-step-size": 30,
  "target-arrow-shape": "triangle",
  "target-arrow-color": "green",
  "line-color": "green",
  width: 2,
  "text-background-color": "white",
  "text-background-opacity": 1,
};

export const visitingNodeStyle = {
  "background-color": "grey",
};
